import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconClipboard"><Path fillRule="evenodd" clipRule="evenodd" d="M15.95 4H17.5C18.8807 4 20 5.11929 20 6.5V19.5C20 20.8807 18.8807 22 17.5 22H6.5C5.11929 22 4 20.8807 4 19.5V6.5C4 5.11929 5.11929 4 6.5 4H8.05001C8.28164 2.85888 9.29052 2 10.5 2H13.5C14.7095 2 15.7184 2.85888 15.95 4ZM15 4.5C15 3.67157 14.3284 3 13.5 3H10.5C9.67157 3 9 3.67157 9 4.5V5.5C9 5.77614 9.22386 6 9.5 6H14.5C14.7761 6 15 5.77614 15 5.5V4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClipboard;
